const WEAPON_ICONS: Record<string, string> = {
  WoodClub: 'Weapons/wood_club/wood_club_icon.png',
  'Nerd Weapon': 'Weapons/nerd_weapon/nerd_weapon_icon.png',
};

const HEAD_ITEMS: Record<string, string> = {
  'Pink Hunter Fur Shoulderpads': 'Head/pink_hunter_fur_shoulderpads.png',
};

const BODY_ITEMS: Record<string, string> = {
  'Pink Hunter Fur': 'Body/pink_hunter_fur.png',
  'Unfinished Pink Hunter Fur Coat': 'Body/unfinished_pink_hunter_fur_coat.png',
};

const CRAFTING_SLUGS: Record<string, string> = {
  Amber: 'amber',
  'Amber Drop': 'amber',
  Claws: 'claws',
  Gold: 'gold',
  'Gold drop': 'gold',
  Ice: 'ice',
  Leather: 'leather',
  Metal: 'metal',
  'Metal Drop': 'metal',
  Obsidian: 'obsidian',
  'Obsidian Drop': 'obsidian',
  Opal: 'opal',
  'Opal Drop': 'opal',
  'Pink Fur': 'pink_fur',
  Stone: 'stone',
  'Stone drop': 'stone',
  Wood: 'wood',
  'Wood Drop': 'wood',
  'Sticky Stick': 'sticky_stick',
  'Dodo Feather': 'dodo_feather',
};

export function getItemImagePath(name: string) {
  const clean = name.replace(/\.png$/i, '').trim();
  if (!clean) return '';
  if (clean.includes('Dust ')) return `Misc/Dust drop/${clean}.png`;
  if (WEAPON_ICONS[clean]) return WEAPON_ICONS[clean];
  if (HEAD_ITEMS[clean]) return HEAD_ITEMS[clean];
  if (BODY_ITEMS[clean]) return BODY_ITEMS[clean];
  const slug = CRAFTING_SLUGS[clean];
  if (!slug) return '';
  return `Crafting/${slug}.png`;
}

export function itemTextureKey(name: string) {
  return `item-icon-${String(name || 'unknown').replace(/[^a-z0-9]+/gi, '_')}`;
}
